import React, { useState } from 'react';
import styles from './ImageWithLoader.module.css';

interface Props {
  src: string;
  alt?: string;
  className?: string;
}

const ImageWithLoader: React.FC<Props> = ({ src, alt = '', className = '' }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className={`${styles.imageWrapper} ${className}`}>
      {loading && <div className={styles.loader}></div>}
      <img
        src={src}
        alt={alt}
        className={`${styles.image} ${loading ? styles.hidden : ''}`}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default ImageWithLoader;
